import styled from '@emotion/styled';
import { DatePicker as CyDatePicker, DatePickerProps } from '@applyboard/crystal-ui';

export function DatePicker(props: DatePickerProps) {
  return (
    <Styles>
      <CyDatePicker {...props} />
    </Styles>
  );
}

const Styles = styled.div({
  '& > div > div': {
    backgroundColor: '#f3f3f3',
    border: 0,
  },
});
